import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { TranslateService } from 'src/modules/base/services/translate.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { PopupFormComponent } from 'src/modules/base/components/popupform/popupform.component';
import { SmartModalService, ModalSize } from 'src/modules/base/services/smart-modal.service';
import { FormService } from 'src/modules/base/components/form/form.service';
import { FormControl } from '@angular/forms';
@Component({
  selector: 'app-consent-form',
  standalone: false,
  templateUrl: './consent-form.component.html',
  styleUrl: './consent-form.component.scss'
})
export class ConsentFormComponent implements OnInit {
  bannerData: any = {};
  config: any;
  emitTemp: boolean = false
  resourceDef: any;
  _currentData = {
    "donor_id": "DONORID2026/156",
    "donor_requisition_no": "REQUEST2026-227",
    "template": {}
  }

  constructor(
    private baseService: BaseService,
    private translateService: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private alerts: AlertsService,
    private loader: LoaderService,
    private changeDetect: ChangeDetectorRef,
    public smartModalService: SmartModalService,
    private formService: FormService

  ) { }

  ngOnInit(): void {
    this.baseService.getResourceDef('appointment_popup_form', (data) => {
      this.resourceDef = data;
      this.config = this.resourceDef.config
    })
    this.viewTemplate()
  }


  viewTemplate() {
    let objTemplate = {
      "application": "emr",
      "resource": "observation_template",
      "args": "templateType:blood_bank,template_sub_type:donor_screening",
      "query_id": "GET_PAGE",
      "filter": "donor_id:" + this._currentData.donor_id + ",donor_requisition_no:" + this._currentData.donor_requisition_no
    }
    this.baseService.getByDataSource(objTemplate).subscribe({
      next: (res) => {
        if (res.errCode == 0) {
          this._currentData = res.resource[0]
          this.autoFilltemplateName()
        }
      },
      error: (err) => {
        console.log(err);
        this.alerts.error('API error');
      }
    })
  }


  autoFilltemplateName() {
    setTimeout(() => {
      this.config.parentForm.controls.template_id.setValue(this._currentData['template_id'])
    }, 1000);
  }

  optionChanged(question: any, data: any) {
    console.log(question);
    if (!this.emitTemp && question?.key === "template_id" && question?.defaultsetting?.createComponentDatasource) {
      this.emitTemp = true;
    } else {
      const templateId = data?.form?.value?.template_id;
      question.value ||= templateId;
      question.defaultsetting.preserveTemplate = false
    }
  }

  questionValueChanged(event) {
    this.optionChanged(event.question.question, event)
  }


}
